import Aos from 'aos';
import { Suspense, useEffect } from 'react';

import { Navbar } from '@app/components/Navbar';
import { Footer } from '@app/components/Footer';
import { Guide } from '@app/components/Guide';

import 'aos/dist/aos.css';

/** Describes duration aos effects time in milliseconds. */
const DURATION_TIME: number = 1500;

const HowToUse = () => {
    useEffect(() => {
        Aos.init({
            duration: DURATION_TIME,
        });
    }, []);

    return (
        <Suspense fallback="">
            <Navbar />
            <main className="main">
                <Guide />
            </main>
            <Footer />
        </Suspense>
    );
};

export default HowToUse;
